export const state = () => ({
  prevRoute: null,
})

export const getters = {
  getPrevRoute: (state) => state.prevRoute,
}

export const mutations = {
  SET_PREV_ROUTE(state, route) {
    state.prevRoute = route
  },
}
